import request from '@/utils/request'


// 查询热搜商品列表
export function listSearchHotGood(query) {
  return request({
    url: '/search/search/hot/good/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询热搜商品分页
export function pageSearchHotGood(query) {
  return request({
    url: '/search/search/hot/good/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询热搜商品详细
export function getSearchHotGood(data) {
  return request({
    url: '/search/search/hot/good/detail',
    method: 'get',
    params: data
  })
}

// 新增热搜商品
export function addSearchHotGood(data) {
  return request({
    url: '/search/search/hot/good/add',
    method: 'post',
    data: data
  })
}

// 修改热搜商品
export function updateSearchHotGood(data) {
  return request({
    url: '/search/search/hot/good/edit',
    method: 'post',
    data: data
  })
}

// 删除热搜商品
export function delSearchHotGood(data) {
  return request({
    url: '/search/search/hot/good/delete',
    method: 'post',
    data: data
  })
}
